/*
 * -----------------------------------------------------------------------
 *  <copyright file="drag-handle-cell/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';
import { GRID_COL_INDEX_ATTRIBUTE, GridCellProps } from '@progress/kendo-react-grid';
import cn from 'clsx';
import React from 'react';

interface DragHandleCellProps extends GridCellProps {
    firstCol?: boolean;
}

const DragHandleCell = ({
    field = '',
    dataItem,
    id,
    colSpan,
    ariaColumnIndex,
    isSelected,
    columnIndex,
    firstCol,
}: DragHandleCellProps) => {
    const value = dataItem[field];
    const navigationAttributes = useTableKeyboardNavigation(id);

    return (
        <td
            className={cn({ 'drag-and-drop-cell': firstCol })}
            style={{ cursor: 'move' }}
            colSpan={colSpan}
            role="gridcell"
            aria-colindex={ariaColumnIndex}
            aria-selected={isSelected}
            data-drag-handle
            {...{ [GRID_COL_INDEX_ATTRIBUTE]: columnIndex }}
            {...navigationAttributes}
            data-testid="drag-and-drop-cell"
        >
            {firstCol ? (
                <>
                    <div
                        className="overlap"
                        role="gridcell"
                        aria-colindex={ariaColumnIndex}
                        aria-selected={isSelected}
                        data-drag-handle
                        {...{ [GRID_COL_INDEX_ATTRIBUTE]: columnIndex }}
                        {...navigationAttributes}
                    />
                    <FontAwesomeIcon icon={['fal', 'arrows-up-down-left-right']} />
                </>
            ) : value === null ? (
                ''
            ) : (
                dataItem[field]?.toString()
            )}
        </td>
    );
};

export default DragHandleCell;
